import { ResourceType } from '../../enumerations/ResourceType';
import { ParentedArtifactResource } from '../artifactResourceTypes';
import { AddToIndexMutateObject, AddToIndexMutateObjectSchema, UpdateIndexMutateObject, UpdateIndexMutateObjectSchema } from '../mutateObjects';
import { PersistableSchemaType } from '../persistableResourceTypes';
import { useMutationWithDelay } from '../useMutationWithDelay';
import { useMultiResourceSingleParentedResourceAdapterBaseActions } from './useMultiResourceSingleParentedResourceAdapterBaseActions';

export function useMultiOrderedResourceSingleParentedResourceAdapterActions<R extends ParentedArtifactResource>(
    apiPostfix: string,
    resourceType: ResourceType,
    resourceSchema: PersistableSchemaType<R>
) {
    const actions = useMultiResourceSingleParentedResourceAdapterBaseActions(apiPostfix, resourceType, resourceSchema);

    const useAddResourceToIndex = () => {
        return useMutationWithDelay(
            (mutateObject: AddToIndexMutateObject<R>) => actions.addResourceToIndex(mutateObject.resource, mutateObject.index, mutateObject.parentId),
            AddToIndexMutateObjectSchema
        );
    };

    // TODO use or remove
    const useChangeIndexOfResource = () => {
        return useMutationWithDelay(
            (mutateObject: UpdateIndexMutateObject<R>) => actions.changeIndexOfResource(mutateObject.resource, mutateObject.index, mutateObject.parentId),
            UpdateIndexMutateObjectSchema
        );
    };

    return {
        useValidateResource: actions.useValidateResource,
        useValidateAllResourcesSingleParented: actions.useValidateAllResourcesSingleParented,
        useGetResource: actions.useGetResource,
        useUpdateResource: actions.useUpdateResource,
        useDeleteResource: actions.useDeleteResource,
        useGetAllResources: actions.useGetAllResources,
        processMutationResponse: actions.processMutationResponse,
        processGetResponse: actions.processGetResponse,
        processGetCollectionResponse: actions.processGetCollectionResponse,
        processGetResourceResponse: actions.processGetResourceResponse,
        useAddResourceToIndex,
        useChangeIndexOfResource,
    };
}
